import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import "./styles.css";
import ModalAlert from "../../common/modal-alert";
import Moment from "react-moment";
import EmployeeTable from "./EmployeeTable";
import "moment-timezone";
import EmployeeForm from "./EmployeeForm";

// Set the timezone for every instance.
Moment.globalTimezone = 'America/Sao_Paulo';


class Company extends Component {
  state = {
    load: false,
    functions: null,
    sectors: null,
    msgSuccess: null,
    msgError: null,
    employees: null,
    integrations: {},
    idEmployee: null,
    integrationSelected: null,
    alterIntegration: false,
    msgAlert: null,
    classText: null,
    openModal: false,
    employeeData: null,
    EmployeeStatus: null,
    companyStatusId: null,
    registerEmployee: true,
    registerEmployee: null
  };

  componentDidMount() {
    this.getCompany();
    this.searchEmployees();
    this.searchFunctions();
    this.searchSectors();
    this.getIntegrations();
    this.searchEmployeeStatus();
  }

  getCompany = async () => {
    await api
      .get(`/companies?cnpj=${localStorage.getItem("cnpj")}`)
      .then(result1 => {
        if (result1.data.rows.length) {
          this.setState({ 
            companyStatusId: result1.data.rows[0].CompanyStatusId, 
            registerEmployee: result1.data.rows[0].CompanyType.register_employee
          });
          localStorage.setItem(
            "companyStatusId",
            result1.data.rows[0].CompanyStatus.id
          );
          localStorage.setItem(
            "companyStatus",
            result1.data.rows[0].CompanyStatus.description
          );
        }
      });
  };

  getIntegrations = async () => {
    await api
      .get(`/integrations?occurrence=FUTURE&order_by=date&open=true`)
      .then(result1 => {
        if (result1.data.rows.length) {
          this.setState({ integrations: result1.data.rows });
        }
      });
  };

  searchSectors = async () => {
    this.setState({ load: true });
    const response = await api.get(`/sectors?status=1`);
    this.setState({ sectors: response.data.rows, load: false });
  };

  searchFunctions = async () => {
    this.setState({ load: true });
    const response = await api.get(`/functions?order_by=description`);
    this.setState({ functions: response.data.rows, load: false });
  };

  searchEmployees = async () => {
    this.setState({ load: true });
    const response = await api.get(
      `/employees?CompanyId=${localStorage.getItem("CompanyId")}`
    );
    this.setState({ employees: response.data.rows, load: false });
  };

  handleOpenModal = () => {
    this.setState({ openModal: !this.state.openModal });
  };

  selectIntegration = data => {
  console.log("TCL: Company -> data", data)
    this.setState({ idEmpolyee: data, msgErro: null, msgAlert: null });
    var radioButtons = document.getElementsByName("optionintegration");
    for (var x = 0; x < radioButtons.length; x++) {
      radioButtons[x].checked = false;
    }
  };

  selectIntegrationItem = e => {
    let idRadio = e.target.id.split("_");
    this.setState({ integrationSelected: idRadio[1] });
  };

  createIntegration = async () => {
    this.setState({ load: true });
    await api
      .post(`/integration-schedules`, {
        IntegrationId: this.state.integrationSelected,
        EmployeeId: this.state.idEmpolyee
      })
      .then(async result => {
        document.getElementById("closeModalCreate").click();
        document.getElementById("modal-alert").click();
        this.setState({
          msgAlert: result.data.msg,
          classText: "text-success",
          load: false
        });

        // await api.patch(`/employees/${this.state.idEmpolyee}`, { EmployeeStatusId: 5 });

        this.searchEmployees();
        this.getIntegrations();
      })
      .catch((error) => {
        let msg = error.response.data.msg;
        this.setState({
          msgError: msg
            ? msg
            : "Não foi possível agendar a integração! Tente novamente.",
          load: false
        });
      });
  };

  searchEmployeeStatus = async () => {
    await api
      .get(`/employee-status`)
      .then(result => {
        this.setState({ EmployeeStatus: result.data.rows });
      })
      .catch(errors => {
        console.log("TCL: fetchMyAPI -> errors", errors);
      });
  };
  
  /*
   * Função para passar os dados do usuário selecionado
   * vindo do componente filho (tabela) > atualizando o estado do pai (este componente) > repassando para o filho EmployeeForm
   */
  callbackFunction = childData => {
    this.setState({
      employeeData: childData,
      openModal: !this.state.openModal
    });
  };

  deleteEmployee = async oldData => {
    this.setState({ load: true });
    if (oldData.id) {
      await api
        .delete(`/employees/${oldData.id}`)
        .then(res => {
          const data = [...this.state.employees];
          data.splice(data.indexOf(oldData), 1);
          this.setState({
            load: false,
            msgSuccess: res.data.msg,
            msgError: null,
            employees: data
          });
        })
        .catch(({ response }) => {
          this.setState({
            msgError: response.data.msg,
            msgSuccess: null,
            load: false
          });
        });
    }
  };
  updateEmployee = async (newData) => {
    this.setState({ load: true, msgError: null, msgSuccess: null });
    await api
      .patch(`/employees/${newData.id}/data`, newData)
      .then(async res => {
        await this.searchEmployees();
        this.setState({
          msgSuccess: res.data.msg,
          load: false
        });
        return res;
      })
      .catch(({ response }) => {
        this.setState({ msgError: response.data.msg, load: false });
        return response;
      });
    // }
  };

  createEmployee = async childData => {
    await this.searchEmployees();
    this.setState({ 
      openModal: false, 
      employeeData: null 
    });
  };

  render() {
    const {
      functions,
      sectors,
      validityDate,
      employeeData,
      openModal,
      employees,
      EmployeeStatus,
      msgError,
      msgSuccess,
      load,
      companyStatusId,
      registerEmployee
    } = this.state;

    return (
      <Fragment>
      
        <EmployeeTable
          selectIntegration={this.selectIntegration}
          currentEmployee={this.callbackFunction}
          deleteEmployee={this.deleteEmployee}
          loading={load}
          openModal={openModal}
          functions={functions}
          sectors={sectors}
          employees={employees}
          status={EmployeeStatus}
        />


        {msgSuccess ? (
          <div className="text-center col-md-12 p-t-20">
            <div className="alert alert-success">{msgSuccess}</div>
          </div>
        ) : null}
        {msgError ? (
          <div className="text-center col-md-12 p-t-20">
            <div className="alert alert-danger">{msgError}</div>
          </div>
        ) : null}
        
        {companyStatusId == 5 && registerEmployee ? (
          <button
            onClick={ () => this.setState({ openModal: !openModal, employeeData: null }) }
            className="btn btn-success m-3"
          >
            Cadastrar Colaborador
          </button>
        ) : (
          <div className="text-center col-md-12 p-t-20">
            { ! registerEmployee ? 
              <div className="alert alert-danger"> Este tipo de empresa não pode cadastrar colaboradores!</div>
            : 
              <div className="alert alert-danger"> Sua empresa precisa estar com o status <b>'HABILITADO'</b> para cadastrar colaboradores!</div>
            }
          </div>
        )}

        <EmployeeForm
          functions={functions}
          sectors={sectors}
          open={openModal}
          employeeData={employeeData}
          createEmployee={this.createEmployee}
          updateEmployee={this.updateEmployee}
          handleOpenModal={this.handleOpenModal}
        />

        <ModalAlert
          title="Informação"
          msg={this.state.msgAlert}
          function=""
          classText={this.state.classText}
        />

        <div
          className="modal fade modal-integration"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Cadastrar Integração
                  {this.state.load ? (
                    <i className="fa fa-spin fa-spinner"></i>
                  ) : null}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="alert alert-info">
                        Selecione a data que deseja agendar a integração!
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="row">
                        {this.state.integrations.length
                          ? this.state.integrations.map(item => {
                              return (
                                <div className="col-md-4" key={item.id}>
                                  <input
                                    type="radio"
                                    name="optionintegration"
                                    className="with-gap radio-col-purple"
                                    id={"radio_" + item.id}
                                    value={item.id}
                                    onClick={this.selectIntegrationItem}
                                  />
                                  <label
                                    htmlFor={"radio_" + item.id}
                                    id={"radio_" + item.id}
                                    onClick={this.selectIntegrationItem}
                                  >
                                    
                                    <Moment format="DD/MM/YYYY HH:mm"  tz="America/Sao_Paulo"> 
                                      {item.date}
                                    </Moment>
                                    | ID: {item.id}
                                    <br />
                                  </label>
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </div>

                    {this.state.msgError ? (
                      <div className="col-md-12">
                        <div className="alert alert-danger">
                          {this.state.msgError}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                {this.state.load ? (
                  <i className="fa fa-spin fa-spinner"></i>
                ) : null}

                {!this.state.alterIntegration ? (
                  <button
                    className="col-md-3 btn waves-effect waves-light btn-rounded btn-success"
                    onClick={this.createIntegration}
                  >
                    Agendar Integração
                  </button>
                ) : (
                  <button
                    className="col-md-3 btn waves-effect waves-light btn-rounded btn-success"
                    onClick={this.ActionAlterIntegration}
                  >
                    Alterar Integração
                  </button>
                )}

                <button
                  type="button"
                  id="closeModalCreate"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Company;
